import { type RJSFSchema } from '@rjsf/utils';
import { z } from 'zod/v4';
// Import SchemaAttribute as a Zod schema from your utils/constants
export const AttributeSchemaDTO = z.object({
  schema: z.any(),
  uiSchema: z.any(),
});
export interface AttributeSchema {
  schema: RJSFSchema;
  uiSchema: RJSFSchema;
  // preset?: string;
  // required?: boolean;
}

// AttributeModifiersDTO
export const AttributeModifiersDTO = z.object({
  hidden: z.boolean(),
  editable: z.boolean(),
  required: z.boolean(),
  save_history: z.boolean(),
});
export type AttributeModifiers = z.infer<typeof AttributeModifiersDTO>;

export const AttributeValueTypeDTO = z.enum([
  'STRING',
  'TEXT',
  'INT',
  'FLOAT',
  'DATETIME',
  'BOOL',
  'STRING_LIST',
  'JSONB',
  'INET',
  'FILE', //TODO UPCHECK
]);

export type AttributeValueType = z.infer<typeof AttributeValueTypeDTO>;

// AttributeDTO
export const AttributeDTO = z.object({
  id: z.uuid(),
  name: z.string(),
  label: z.string(),
  system_function: z.boolean().optional(),
  tags: z.array(z.string()).optional(),
  value_schema: AttributeSchemaDTO,
});
export type Attribute = z.infer<typeof AttributeDTO>;

// AttributeCreateDTO (AttributeDTO without 'id')
export const AttributeCreateDTO = AttributeDTO.omit({ id: true });
export type AttributeCreate = z.infer<typeof AttributeCreateDTO>;